

const CLIENT_ID: number = 1;

export function getClientId(): number {
  return CLIENT_ID;
}
